import { useLazyQuery } from '@apollo/client';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { useEffect } from 'react';
import { errorHandler } from 'utils/ErrorHandler';
import HackleManager from 'utils/hackle';
import { STORAGE_KEY } from 'utils/localStoarge';
import {
  callWebviewHandler,
  isWebview,
  WebviewOperatorType,
} from 'utils/webview';
import { GET_ME } from '../Constants';
import { MeData } from '../types';

export function useGetMe() {
  const { setUserInfo, clearUserInfo } = useUserInformation();
  const [getUser, { data, refetch }] = useLazyQuery(GET_ME);

  const handleGetUser = async () => {
    try {
      const response = await getUser();

      if (response.error) {
        const isNotAuthorized =
          (response.error.cause as any).result.errors[0].extensions.code ===
          'NOT_AUTHORIZED';

        if (isNotAuthorized) {
          window.showToast('잘못된 인증 정보입니다.', 'failed');

          clearUserInfo();

          HackleManager.logSignoutComplete();
          HackleManager.userLogout();

          window.handleCloseLoading();

          if (isWebview()) {
            localStorage.removeItem(STORAGE_KEY.IS_HOST_ADMIN_APP);
            callWebviewHandler(WebviewOperatorType.LogoutHandler);

            return;
          }

          if (!isWebview()) {
            window.location.href = '/sign-in';
          }
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleGetUserInformation = () => {
    if (localStorage.getItem(STORAGE_KEY.AUTHORIZATION)) {
      handleGetUser();
    } else {
      return;
    }
  };

  const handleRefetchUser = async (callback?: (myInfo?: MeData) => void) => {
    try {
      const response = await refetch();

      if (response) {
        setUserInfo(response.data);

        callback && callback(response.data);
      }
    } catch (error) {
      console.log('error', error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (data) {
      setUserInfo(data);
    }
  }, [data]);

  return { handleGetUserInformation, handleRefetchUser, getUser, data };
}
